import { BaseModal } from './BaseModal'
import {
  PlayIcon,
  QuestionMarkCircleIcon,
  ChartBarIcon,
  CogIcon,
} from '@heroicons/react/outline'

type Props = {
  isOpen: boolean
  handleClose: () => void
  setIsMenuModalOpen: (value: boolean) => void
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}

export const MenuModal = ({
      setIsMenuModalOpen,
      setIsInfoModalOpen,
      setIsStatsModalOpen,
      setIsSettingsModalOpen,
      isOpen, handleClose }: Props) => {
  return (

    <BaseModal title="" isOpen={isOpen} handleClose={handleClose}>

      <div className="flex justify-center">
      <a href="https://omtamil.com">
        <img src="https://omtamil.com/logo/omtamil.png" width="60px" alt="OMTAMIL"></img></a>       
        </div>

        <div className="flex mt-3 justify-center">
       <img src="https://omtamil.com/logo/soladle.png" width="140px" alt="சொல்லாடல்"></img>
       </div>

       <p className="mt-3 italic text-base text-gray-500 dark:text-gray-300">
       சொல்லை எழுத்துகளால் கண்டுபிடிக்கும் விளையாட்டு செயலி</p>

       <div className="flex mt-1  justify-center">
        <button
              type="button"
              className="mt-1 inline-flex w-60 items-center justify-center rounded-lg border-4 border-green-900 bg-emerald-500 py-1 text-white hover:bg-emerald-400 text-2xl"
              onClick={() => setIsMenuModalOpen(false)}
              >
        <PlayIcon
          className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"/>
            விளையாடு
            </button>
            </div>

        <div className="flex mt-1  justify-center">
        <button
              type="button"
              className="mt-0 inline-flex w-60 items-center justify-center rounded-lg border-4 border-green-900 bg-emerald-500 py-1 text-white hover:bg-emerald-400 text-2xl"
              onClick={() => setIsInfoModalOpen(true)}>
        <QuestionMarkCircleIcon
          className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"/>
            வழிமுறை
            </button>
            </div>

        <div className="flex mt-1  justify-center">    
        <button
              type="button"
              className="mt-0 inline-flex w-60 items-center justify-center rounded-lg border-4 border-green-900 bg-emerald-500 py-1 text-white hover:bg-emerald-400 text-2xl"
              onClick={() => setIsStatsModalOpen(true)}>
          <ChartBarIcon
            className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"/>
            புள்ளியல்
            </button>
            </div>
            <div className="flex mt-1  justify-center">   
          <button
              type="button"
              className="mt-0 inline-flex w-60 items-center justify-center rounded-lg border-4 border-green-900 bg-emerald-500 py-1 text-white hover:bg-emerald-400 text-2xl"
              onClick={() => setIsSettingsModalOpen(true)}>
            <CogIcon
            className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"/>
            அமைப்புகள்
            </button>
            </div>

     <div className="flex mt-4 justify-left mx-1">
     <a href="https://omtamil.com/sorputhir"><img src="https://omtamil.com/logo/sorputhir.png" width="100px" alt="சொற்புதிர்"></img></a> 
     <div className="mx-1"></div>
     <a href="https://omtamil.com/sotredal"><img src="https://omtamil.com/logo/sotredal.png" width="100px" alt="சொற்றேடல்"></img></a>
      <div className="mx-1"></div>
     <a href="https://omtamil.com/solvarisai"><img src="https://omtamil.com/logo/solvarisai.png" width="100px" alt="சொல்வரிசை"></img></a>  

      </div>   
      
    </BaseModal>
  )
}
